import React, { useEffect, useState } from 'react';

import styled from 'styled-components';

import { useUserPermission } from '@contexts/UserContext';

import FlexContainer from '@components/Gui/FlexContainer';
import { NwCard } from '@components/Gui/NwCard/NwCard';
import NwDrawer from '@components/Gui/NwDrawer';
import NwDropDownMenu from '@components/Gui/NwDropDownMenu';
import ResponsiveFlexContainer from '@components/Gui/ResponsiveFlexContainer';
import PlayListInfoForm from '@components/MediaDrawer/PlayListInfoForm';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const DetailsContainer = styled.div`
    flex: 1 1 0;
`;
const PlaylistDetails = ({ playlist, isEdit, onUpdatePlaylists, onDeletePlayList }) => {
    const [editMode, setEditMode] = useState(false);
    const [touchForm, setTouchForm] = useState(false);
    const userPermission = useUserPermission('DeleteBooks', [playlist.UserCreated]);

    useEffect(() => {
        if (isEdit) {
            setEditMode(true);
        }
    }, [isEdit]);

    const renderContent = () => {
        return (
            <FlexContainer alignItems="flex-start" justifyContent="space-between" fullWidth>
                <DetailsContainer>
                    <ResponsiveFlexContainer
                        leftMinWidth={140}
                        columns={[
                            {
                                content: <p className="is-label">Name</p>,
                                isBorder: true,
                                width: '30%',
                            },
                            {
                                content: <p className="is-content">{playlist.Name}</p>,
                                isBorder: false,
                            },
                        ]}
                    />
                    <ResponsiveFlexContainer
                        leftMinWidth={140}
                        columns={[
                            {
                                content: <p className="is-label">Description</p>,
                                isBorder: true,
                                width: '30%',
                            },
                            {
                                content: <p className="is-content">{playlist.Description}</p>,
                                isBorder: false,
                            },
                        ]}
                    />
                    <ResponsiveFlexContainer
                        leftMinWidth={140}
                        columns={[
                            {
                                content: <p className="is-label">Privacy Level</p>,
                                isBorder: true,
                                width: '30%',
                            },
                            {
                                content: <p className="is-content">{playlist.PrivacyLevelName}</p>,
                                isBorder: false,
                            },
                        ]}
                    />
                </DetailsContainer>
                <NwDropDownMenu
                    actions={[
                        {
                            name: '',
                            key: 'edit',
                            pinned: true,
                            icon: byPrefixAndName.fasl['pen'],
                            action: () => setEditMode(true),
                        },
                        {
                            name: 'delete',
                            type: 'delete',
                            key: 'delete',
                            icon: byPrefixAndName.fasl['trash-alt'],
                            confirmationPlacement: 'left',
                            disabled: !userPermission,
                            action: () => onDeletePlayList(),
                        },
                    ]}
                />
            </FlexContainer>
        );
    };

    return (
        <NwCard title="Info" icon={byPrefixAndName.fasl['info-square']}>
            {renderContent()}
            {editMode && (
                <NwDrawer
                    touchForm={touchForm}
                    onTouchForm={setTouchForm}
                    title="Edit Book"
                    onClose={() => setEditMode(false)}
                >
                    <PlayListInfoForm
                        playlist={playlist}
                        onUpdatePlaylists={onUpdatePlaylists}
                        onTouchForm={setTouchForm}
                        onClose={() => setEditMode(false)}
                    />
                </NwDrawer>
            )}
        </NwCard>
    );
};

export default PlaylistDetails;
